export enum CommunicationKitFormat {
  Poster = 'poster',
  Banner = 'banner',
  SocialMedia = 'social-media',
}
